import React from "react";
import { ChevronLeft } from "lucide-react";

const YourAccountPage = ({ onBack }) => (
  <div>
    <button
      onClick={onBack}
      className="flex items-center gap-1 mb-3 text-sm text-gray-600"
    >
      <ChevronLeft size={18} /> Back
    </button>
    <h3 className="text-lg font-semibold mb-3 text-gray-800">Your Account</h3>
    <ul className="space-y-2">
      <li className="p-2 border rounded-md hover:bg-gray-50 cursor-pointer">
        Profile Settings
      </li>
      <li className="p-2 border rounded-md hover:bg-gray-50 cursor-pointer">
        Payment Methods
      </li>
      <li className="p-2 border rounded-md hover:bg-gray-50 cursor-pointer">
        Saved Addresses
      </li>
      <li className="p-2 border rounded-md hover:bg-gray-50 cursor-pointer">
        Wishlist
      </li>
    </ul>
  </div>
);

export default YourAccountPage;
